import { gql, useQuery } from '@apollo/client';
import { SecurityDetailsQuery } from './types';

const SECURITY_DETAILS_QUERY = gql`
    query GetSecurityDetails(
        $securityId: Long
        $documentTags: [String]
        $portfolioId: Long
        $securityIds: [Long]
        $includeTransactions: Boolean!
    ) {
        security(id: $securityId) {
            id
            name
            namesAsMap
            securityCode
            isinCode
            url
            url2
            currency {
                securityCode
                amountDecimalCount
            }
            latestMarketData {
                id
                date: obsDate
                price: closeView
            }
            type {
                id
                code
                namesAsMap
                name
            }
            tagsAsSet
            documents(filterTags: $documentTags) {
                fileName
                identifier
                mimeType
            }
            groups {
                id
                code
                name
            }
            amountDecimalCount
        }
        transactionsByParameters(parameters: { portfolioId: $portfolioId, securityIds: $securityIds }) @include(if: $includeTransactions) {
            transactionDate
        }
    }
`;

export const useGetSecurityDetails = (securityId: string | undefined, portfolioId?: number) => {
    const securityIdAsNumber = securityId != null ? Number(securityId) : undefined;
    const includeTransactions = Boolean(portfolioId && securityIdAsNumber);
    const securityIds = includeTransactions && securityIdAsNumber ? [securityIdAsNumber] : undefined;
    const { loading, error, data } = useQuery<SecurityDetailsQuery>(SECURITY_DETAILS_QUERY, {
        variables: {
            securityId: securityIdAsNumber ?? securityId,
            documentTags: ['Online'],
            portfolioId,
            securityIds,
            includeTransactions,
        },
        skip: !securityId,
    });

    return {
        loading,
        error,
        data: data?.security,
        transactions: data?.transactionsByParameters,
    };
};
